
import Vue from 'vue';
import api from '@/api/api';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { columns } from '@/utils/columns';
import Grid from '@/components/Grid.vue';
import ModalCrud from '@/components/ModalCrud.vue';
import MultipleSelect from '@/components/MultipleSelect.vue';

export default Vue.extend({
	name: 'Regioes',
	data() {
		return {
			grid: {
				isLoading: false,
				columns: columns.cadastros.regioes,
				dataset: []
			},
			gridItemsActions: [
				{
					label: 'Editar',
					action: 'edit',
					icon: 'mdi-pencil',
					color: 'primary',
					display: true,
					loading: false
				},
				{
					label: 'Vincular Cidades',
					action: 'link-cities',
					icon: 'mdi-map-marker-radius',
					color: 'success',
					display: true,
					loading: false
				},
			],
			modals: {
				criarEditarRegiao: {
					isLoading: false,
					visible: false,
					title: ''
				},
				vincularCidades: {
					isLoading: false,
					visible: false,
					title: ''
				},
			},
			forms: {
				criarEditarRegiao: {
					data: {
						id: 0,
						descricao: '',
						idStatus: false
					},
					controls: {
						isValid: true,
						rules: [
							v => !!v || 'Descrição precisa ser preenchida.',
						]
					}
				},
				vincularCidades: {
					data: {
						idRegiao: 0,
						cidades: []
					},
					dataset: {
						cidades: []
					}
				}
			},
		}
	},
	components: {
		Grid,
		ModalCrud,
		MultipleSelect,
	},
	methods: {
		loadDataGrid: async function () {
			try {
				this.grid.isLoading = true;

				const response = await api.get('/region');
				this.grid.dataset = response.data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.grid.isLoading = false;
			}
		},
		showModalNewEditRegion: async function (item) {
			try {
				this.modals.criarEditarRegiao.title = item.ID ? `${item.ID} - Editar Região` : 'Nova região';
				this.modals.criarEditarRegiao.visible = true;
				this.modals.criarEditarRegiao.isLoading = true;

				if (item.ID) {
					const response = await api.get(`/region/${item.ID}`);
					const { ID, DESCRICAO, ID_STATUS } = response.data;

					this.forms.criarEditarRegiao.data = {
						id: ID,
						descricao: DESCRICAO,
						idStatus: ID_STATUS === 'A'
					};
				};
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.criarEditarRegiao.isLoading = false;
			}
		},
		closeModalNewEditRegion: function () {
			this.modals.criarEditarRegiao.visible = false;
			this.forms.criarEditarRegiao.data = {
				id: 0,
				descricao: '',
				idStatus: false
			};
		},
		saveRegion: async function () {
			try {
				if (this.$refs.form.validate()) {
					this.modals.criarEditarRegiao.isLoading = true;

					const [metodo, mensagem] = this.forms.criarEditarRegiao.data.id ? ['put', 'alterada'] : ['post', 'criada'];
					await api[metodo]('/region', this.forms.criarEditarRegiao.data);

					this.$toast.success(`Região ${mensagem} com sucesso!`);
					this.closeModalNewEditRegion();
					this.loadDataGrid();
				} else {
					this.$toast.warning('Formulário inválido! Verifique os dados.');
				}
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.criarEditarRegiao.isLoading = false;
			}
		},
		showModalLinkCities: async function (item) {
			try {
				this.modals.vincularCidades.title = `Vincular Cidades - ${item.DESCRICAO}`;
				this.modals.vincularCidades.visible = true;
				this.modals.vincularCidades.isLoading = true;

				this.forms.vincularCidades.data = {
					idRegiao: item.ID,
					cidades: []
				};

				const response = await api.get(`/region/link-cities/${item.ID}`);

				this.forms.vincularCidades.dataset.cidades = response.data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.vincularCidades.isLoading = false;
			}
		},
		closeModalLinkCities: function () {
			this.modals.vincularCidades.visible = false;
			this.forms.vincularCidades.data = {
				idRegiao: 0,
				cidades: []
			};
		},
		saveLinkCities: async function () {
			try {
				this.modals.vincularCidades.isLoading = true;

				await api.post('/region/link-cities', this.forms.vincularCidades.data);

				this.$toast.success(`Vinculo criado com sucesso!`);
				this.closeModalLinkCities();
				this.loadDataGrid();
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.vincularCidades.isLoading = false;
			}
		},
		handleGridItemsActions: function (action: 'edit' | 'link-cities', item) {
			switch (action) {
				case 'edit':
					this.showModalNewEditRegion(item);
					break;
				case 'link-cities':
					this.showModalLinkCities(item);
					break;
				default:
					this.$toast.error('Opção de ação inválida!');
			};
		},
	},
	async mounted() {
		store.commit(M_MENU, "Regiões");
		await this.loadDataGrid();
	},
})

